import usePermissions from "@/hooks/use-permissions";
import { CanRequest } from "@/hooks/use-user-permissions";
import { FC, ReactNode } from "react";
import { Navigate, Outlet } from "react-router";

const CanGuard: FC<{
  permission: CanRequest;
  children?: ReactNode;
}> = ({ permission, children }) => {
  const { can } = usePermissions();

  if (!can(permission)) return <Navigate to="/" replace />;
  return children ?? <Outlet />;
};

export default CanGuard;
